import { decorate, inject, injectable } from 'inversify'
import { makeAutoObservable, runInAction } from 'mobx'

import { Api } from '@evertel/api'
import { DepartmentStore } from '@evertel/department'
import { downloadCSVFile } from '@evertel/utils'

import type { APIDataRoom } from '@evertel/types'

class RoomsUsersExportController {
    room: APIDataRoom = undefined
    isExporting = false

    constructor(
        private api: Api,
        private departmentStore: DepartmentStore
    ) {
        makeAutoObservable(this)
    }

    init({ room }: { room: APIDataRoom }) {
        this.room = room
    }

    async downloadRoomUsersCSV(fileName: string | undefined = undefined) {
        runInAction(() => {
            this.isExporting = true
        })
        try {
            const departmentName = this.departmentStore.findById(this.room.departmentId).name
            const roomName = this.room.name?.replace(/\s+/g, '-') || 'Room'
            const date = new Date().toISOString().split('T')[0]
            const defaultFileName = [departmentName, roomName, 'Users', date].filter(Boolean).join('-')

            const csvData = await this.api.Routes.Room.getUsersCsv(this.room.id)

            downloadCSVFile(csvData as unknown as Blob, fileName || defaultFileName)
        } catch (error) {
            console.error('Failed to export room users CSV', error)
        } finally {
            runInAction(() => {
                this.isExporting = false
            })
        }
    }
}

decorate(injectable(), RoomsUsersExportController)
decorate(inject(Api), RoomsUsersExportController, 0)
decorate(inject(DepartmentStore), RoomsUsersExportController, 1)

export { RoomsUsersExportController }
